import { createEntityAdapter } from '@ngrx/entity';
import { CampagneUserEntityState } from '@get/api-interfaces';
import { CustomEntityState } from '@get/store/configs/states';

export type IState = CustomEntityState<CampagneUserEntityState>;

export const adapter = createEntityAdapter<CampagneUserEntityState>({
  selectId: o => o.idCampagneUser
});
export const initialState: IState = adapter.getInitialState({
  isLoaded: false,
  isLoading: false,
  actives: []
});

export const campagneUserFeatureKey = 'campagneUser';
